import { OnderwijsLocatieI } from '@models/onderwijs-locatie.model';
import { HttpErrorResponse } from '@angular/common/http';

 
export namespace OnderwijsLocatiesActions {

  export class LoadOnderwijsLocaties {
    static readonly type = '[OnderwijsLocaties] DOE - Load OnderwijsLocaties';
  }

  export class LoadOnderwijsLocatiesSuccess {
    static readonly type = '[OnderwijsLocaties] DOE -  Load OnderwijsLocaties Success';

    constructor(public payload: OnderwijsLocatieI[]) {
    }
  }

  export class LoadOnderwijsLocatiesFailure {
    static readonly type = '[OnderwijsLocaties] DOE -  Load OnderwijsLocaties Failure';

    constructor(public payload: string) {
    }
  }

  export class SelectOnderwijsLocatie {
    static readonly type = '[OnderwijsLocaties] DOE -  Select OnderwijsLocatie';

    constructor(public payload: OnderwijsLocatieI) {
    }
  }

  export class SelectSchool {
    static readonly type = '[OnderwijsLocaties] DOE - Select School';

    constructor(public payload: OnderwijsLocatieI) {
    }
  }

  export class DeselectSchool {
    static readonly type = '[OnderwijsLocaties] DOE - Deselect School';
  }

  export class UpdateOnderwijslocatieMetadata {
    static readonly type = '[OnderwijsLocaties] DOE - Update Onderwijslocatie Metadata';

    constructor(
      public onderwijslocatieId: string,
      public payload: { aanleveringDeelnemersLAS: boolean },
    ) {
    }
  }

  export class UpdateOnderwijslocatieMetadataSuccess {
    static readonly type = '[OnderwijsLocaties] DOE - Update Onderwijslocatie Metadata Success';

    constructor(
      public onderwijslocatieId: string,
      public aanleveringDeelnemersLAS: boolean,
    ) {
    }
  }

  export class UpdateOnderwijslocatieMetadataFailure {
    static readonly type = '[OnderwijsLocaties] DOE - Update Onderwijslocatie Metadata Failure';

    constructor(public payload: string) {
    }
  }

  export class DeleteOnderwijslocatie {
    static readonly type = '[OnderwijsLocaties] DOE - Delete Onderwijslocatie';

    constructor(public onderwijslocatieId: string) {
    }
  }

  export class DeleteOnderwijslocatieSuccess {
    static readonly type = '[OnderwijsLocaties] DOE - Delete Onderwijslocatie Success';

    constructor(public onderwijslocatieId: string) {
    }
  }

  export class DeleteOnderwijslocatieFailure {
    static readonly type = '[OnderwijsLocaties] DOE - Delete Onderwijslocatie Failure';

    constructor(public payload: HttpErrorResponse) {
    }
  }

}
